import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import { DisplayQueryError } from '@infl-ts/util-query-errors';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import { useState } from 'react';
import { ChallengePreview } from './codecs';
import Preview from './preview';
import Skeleton from './skeleton';
import { useChallengePreviewData } from './use-challenge-preview-data';
import { jsx as _jsx } from "react/jsx-runtime";
export var PreviewPlayer = function PreviewPlayer(_ref) {
  var skippableOnboarding = _ref.skippableOnboarding;
  var data = useChallengePreviewData();

  var _useState = useState(0),
      stageIndex = _useState[0],
      setStageIndex = _useState[1];

  return pipe(!data || 'loading' === data ? E.left(null) : E.right(data), E.match(function () {
    return /*#__PURE__*/_jsx(Skeleton, {});
  }, flow(function (data) {
    return ChallengePreview.decode(data !== null && data !== void 0 ? data : '');
  }, E.match(flow(makeDecodeError, function (err) {
    return /*#__PURE__*/_jsx(DisplayQueryError, {
      err: err,
      message: "Could not load challenge preview. Try again"
    });
  }), function (_ref2) {
    var challenge = _ref2.challenge,
        stages = _ref2.stages;
    return /*#__PURE__*/_jsx(Preview, {
      challenge: challenge,
      stages: stages,
      stageIndex: stageIndex,
      setStageIndex: setStageIndex,
      skippableOnboarding: skippableOnboarding
    });
  }))));
};